const CONTENT = {
  gre: {
    quantContentUuids: [
      '01eb680e-f7b7-484e-b155-2dc2dfdbed77',
      '03ab18de-2f1c-4668-a9bc-1d1a13e57af8',
      '07b34e3e-0340-4a09-ae40-8e67d792777c',
      '12109691-0f4c-4792-888d-9d45c95d3357',
      '139ce481-5e11-494e-8d3b-481a8605c987',
      '19f60007-2e85-4bf0-8ba2-2a1ed034fa5d',
      '1a8fe638-ae44-4cc2-ac0a-4d7ed4c60d02',
      '1d0c8019-847b-469c-8c26-3ca6afdfa92c',
      '1e4501e8-02f4-4259-a357-7bd175a01c5a',
      '25208603-5032-4cde-a1ce-bee9cecdccc6',
      '2998db58-e444-4872-9ae7-b3df9296df9f',
      '29b37b99-9163-46b6-948a-46accbd03233',
      '30d99abf-d739-4022-b331-f42378222d10',
      '31bc7946-c0b8-4def-b32b-a05cfbd9e157',
      '31f94913-9e0e-48c2-8d52-e0f261ec8480',
      '3dd380c7-c66c-4237-bbc1-bf344497b67e',
      '405ac256-60cb-4217-8268-f3b2cf9e39ad',
      '4084c96f-2180-401b-a4fb-6bb48216b665',
      '41c832aa-b09f-44a0-8751-0439c99bea56',
      '47ac264b-24a0-41ff-b991-cd73cb8ad911',
      '4b73797a-dfcb-4a5e-adad-bf1702dbc2ff',
      '4fdade0c-b277-4ad9-ad67-01a5aa9d77f6',
      '57a72067-da3c-45fc-ae14-233c1ed8d203',
      '59fa3668-a15a-4205-bf34-82c8d07d1cee',
      '5dfe969f-803e-4e6f-ba12-e06780cc6e22',
      '60859e34-a90c-4f2f-a310-0a2aa5474df6',
      '60e61dd4-37ee-41ca-8438-7d0939ba0d2b',
      '627c9d50-bd2a-4f27-8c74-5a3b36b0433c',
      '67822301-8206-4727-abcd-697b0985cb7f',
      '6988fbec-6d34-475e-a867-6732c5410396',
      '6c3c8c95-cfa5-4477-9536-b76f68829ed7',
      '6fca40e5-9e85-4c1a-9b00-54a8cbe9420b',
      '7a2e1df7-89da-40e7-976c-628fd635dce3',
      '7a568f26-3535-4eae-bcdb-92341dbdc26f',
      '7dea0ee7-bb68-4acf-a49e-7d4356ffb926',
      '841d2bbf-8996-4308-9843-e30fb0503bfb',
      '892fba45-5d0e-49f8-8fa2-5d58422ea254',
      '8984202f-fd12-4ed2-835e-291752e2682a',
      '8eae4a64-2fd5-4136-b76d-a7680c8d4dbc',
      '9bd2a442-fb5e-4cc0-8926-7d8455fdea4d',
      '9fa49179-7891-4205-b0de-b547b377df02',
      'a0f1150e-91c5-4d9f-bb61-ec77ead875ce',
      'b0f9b1f2-c275-4a06-ab5f-67b75f0c4d23',
      'b2c4e202-fecc-4528-9811-14da455c0794',
      'b7c289ca-7b64-44a3-b42d-77c66fa6a76c',
      'bae5601d-1372-414d-abb5-d19dc7d1be18',
      'bc971036-398f-4978-a872-e5b421544516',
      'bee8aa71-7760-4a3a-a344-4bb5132930d2',
      'c4f3a277-e453-46b8-8292-7a0ead8e1620',
      'c7326906-10a5-43f2-b0ae-8213c5751124',
      'c8acb11c-abaf-4fb4-aad5-69158502ed7a',
      'c9de9caf-00e4-4e4e-b5bf-b69523982911',
      'c9fd0ee8-d530-4d72-9384-f1157a9a5e18',
      'cd3f2ef2-2f8c-4428-8bda-8e2ab6346810',
      'cf4acaca-35f6-468c-a619-462314d9036f',
      'd0de223e-6870-45e2-b993-92af753d087b',
      'da5d9d94-648f-4ece-a68f-5e07bd718cc1',
      'dea48006-8740-4a69-ab2f-5286b3faa7b8',
      'df611248-3246-4618-9b61-b341b7d9d4b2',
      'e268d413-8f4f-4d01-82be-a6859e8e0848',
      'e698ceb9-c313-42ff-a22a-16e6f9ca3f67',
      'eaea259c-b007-48d0-ba25-60a8dad98f7f',
      'eaf7fd4d-00fd-4d4f-8e6c-1c2b29f0dc4b',
      'ed4e470a-681c-49aa-b856-eacb79088d20',
      'f274d599-7b8c-4ae6-90e9-c1cdd13ab679',
      'f6a9264d-3a3f-4672-b823-5c115ee95da8',
      'fa13fd49-d285-48ab-8a39-5dd84203fd6d',
      'fd886bf4-24f4-41a5-a4f5-b7c5d54b7ab2',
      'feb47b77-e3c7-4595-8c9c-059e34a3a7ef',
    ],
    vocabContentUuids: [
      '01b22090-4775-4621-a9b9-b5384ca451a2',
      '0cb342d9-60e5-47f1-8a80-4dde90b31d3b',
      '108754e0-6f82-4564-aeac-5581ba5c2aee',
      '10e852d7-6cab-4565-9903-96421e3261cc',
      '1ad112be-24c6-4ea6-b175-306cf2aad669',
      '1c8b8bb5-1505-472d-9c1e-724ab3a34569',
      '23186933-e950-4d26-844d-8bef8cbf1023',
      '2895ef33-4b70-4376-ab66-6a8989fa4b88',
      '294a7bee-80f3-4a98-8bfc-77168ddeec09',
      '2ece0aa6-46a1-4c35-b201-d0c9e330175e',
      '39a0775a-47de-42da-8bf4-44cb00f49765',
      '49cf174f-3de6-4aef-a5f6-cca9ef7c2895',
      '4b026591-e42b-4cc3-8ee8-72cd5130d566',
      '5c3a2c77-c66e-4bbf-b464-b87c97991d41',
      '5fc779b2-a2bf-4510-b315-6a223cd78095',
      '5fda35fd-d71f-44a9-99dc-94ce5d04d840',
      '6b8e4a2e-221f-4dad-adc3-aea919125a16',
      '7211faa9-1230-407a-8c2b-f8e299e4bafd',
      '7aa24e2d-4301-4440-8afd-69adbe729870',
      '8c4d6ead-228e-4778-8faa-2a9ab9434419',
      '8d97aa6b-e2d0-444d-a334-bd6f9f2f82a3',
      '943bb558-e22c-4a07-aca5-0269322faaaf',
      '980cafd1-1ffd-44f3-a7b1-e51f4951071f',
      'a61fd454-d44f-4d0e-a38e-dc463e29bd89',
      'ab3aa9ba-f71b-4103-b7a4-3c5bba07f594',
      'b2517431-a6ca-47ac-8083-6065e349e89f',
      'b2b3bc43-73a3-4548-a63a-c71db672b347',
      'b46f65db-f8a3-4df2-a959-4307272571e1',
      'b790d748-d702-4ffd-bd0c-95a1190dd823',
      'b7fb016d-8b3c-498d-bbaa-f2084b2f0e33',
      'bb676b9b-74c6-432f-95ee-c2fc0cc2c800',
      'c16b76b9-30dc-4fa9-8f22-a8c292780203',
      'c7e27199-203d-476a-938e-bcb09100e93e',
      'c844ca72-3e7a-4665-b06b-87a52e8ae46c',
      'c8a168df-0e1a-433f-bc5a-c9213f7e001b',
      'f41ef4f5-9d55-4abc-a6f2-80d7923576cc',
      'f8ec6bc3-c1fb-4598-b73f-a6900975f070',
    ],
  },
};

module.exports = CONTENT;
